import { FaMapMarkerAlt, FaEnvelope, FaDiscord } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useTranslation } from "../i18n";
import "./ContactInfo.css";

function ContactInfo() {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile(); // Verifica al cargar

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <section className="contact-info-section">
            <div className="contact-info-container">
                {/* 📍 Ubicación */}
                <div className="contact-detail">
                    <FaMapMarkerAlt className="contact-icon" />
                    <h4>{t("contact.location")}</h4>
                    {isMobile ? (
                        <p>{t("contact.city")}, {t("contact.spain")}</p>
                    ) : (
                        <p>{t("contact.city")}, {t("contact.spain")}</p>
                    )}
                </div>

                {/* 📧 Correo Electrónico */}
                <div className="contact-detail">
                    <FaEnvelope className="contact-icon" />
                    <h4>{t("contact.emailLabel")}</h4>
                    {isMobile ? (
                        <p><a className="link" href="mailto:diego.sanchez@theqahub.es">diego.sanchez<br />@theqahub.com</a></p>
                    ) : (
                        <p><a className="link" href="mailto:diego.sanchez@theqahub.es">diego.sanchez@theqahub.com</a></p>
                    )}
                </div>

                {/* Canal de discord */}
                {isMobile ? (
                    <div className="contact-detail">
                        <FaDiscord className="contact-icon" />
                        <h4>{t("contact.discordLabel")}</h4>
                        <p>
                            <a className="link" href="https://discord.gg/Czb4CEbH">
                                {t("contact.joinDiscord").split(" ").slice(0, 4).join(" ")}<br />
                                {t("contact.joinDiscord").split(" ").slice(4).join(" ")}
                            </a>
                        </p>
                    </div>
                ) : (
                    <div className="contact-detail">
                        <FaDiscord className="contact-icon" />
                        <h4>{t("contact.discordCommunity")}</h4>
                        <p>
                            <a className="link" href="https://discord.gg/Czb4CEbH">
                                {t("contact.joinDiscord")}
                            </a>
                        </p>
                    </div>
                )}
            </div>
        </section>
    );
}

export default ContactInfo;
